import debug from 'debug';

const logger = debug('core:application:actions:wasabi');

const FETCH_TIMEOUT = 1000; // Wasabi documentation recommend to use 300ms but the our api usually fail to return with 300ms https://intuit.github.io/wasabi/v1/guide/index.html#code-samples

async function fetchFromApi(experimentLabel, userID) {
  const host = 'wasabi.pluto.tv';
  const pathname = `api/v1/assignments/applications/web/experiments/${experimentLabel}/users/${userID}`;
  const response = await Promise.race([
    fetch(`https://${host}/${pathname}`),
    new Promise((_, reject) => setTimeout(() => reject(new Error('timeout')), FETCH_TIMEOUT)),
  ]);
  return response.json();
}

export const fetchWasabiExperimentThunkAction = (experimentLabel) => async (_, getState) => {
  if (process.env.WASABI_ENABLED !== 'true') {
    logger('wasabi flag not enabled');
    return null;
  }
  const {
    device: { ID: userID },
  } = getState();

  if (!experimentLabel || !userID) {
    return null;
  }

  try {
    logger('requesting wasabi experiment:', { experimentLabel, userID });
    const experimentData = await fetchFromApi(experimentLabel, userID);
    return experimentData;
  } catch (err) {
    logger.extend('error')(err.message);
    return null;
  }
};
